import React from "react";
import { match as matchPropTypes } from "react-router-prop-types";
import { Alert } from "reactstrap";
import ContentLoading from "src/Components/Loading/contentLoading";
import UnsavedChangesPrompt from "src/Components/UnsavedChangesPromt";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { useGetTotalRewardsConfigs } from "src/Pages/Company/TotalReward/api/useConfigs";
import TotalRewardPerksForm from "src/Pages/Company/TotalReward/Perks/Edit/form";

export default function TotalRewardPerkEdit({ match }) {
  const { perkId } = match.params;
  const companyId = useCompanyId();
  const pathPrefix = `/ahr`;

  const { getConfigValue, isLoading, isSuccess, isError, error } =
    useGetTotalRewardsConfigs(companyId);

  return (
    <ContentLoading show={isLoading}>
      {isError && <Alert color="danger">{error.message}</Alert>}
      {isSuccess && (
        <UnsavedChangesPrompt>
          <TotalRewardPerksForm
            perkId={perkId}
            pathPrefix={pathPrefix}
            yourBenefitsEnabled={getConfigValue("your_benefits_module", false)}
            availableBenefitsEnabled={getConfigValue(
              "available_benefits_module",
              false
            )}
            enabledImportPointsBanks={getConfigValue(
              "enable_import_points_bank",
              false
            )}
            enabledPointsBanks={getConfigValue("enabled_point_banks", [])}
            enabledImportBenefits={getConfigValue(
              "enable_import_benefits",
              false
            )}
            enabledBenefits={getConfigValue("enabled_benefits", [])}
          />
        </UnsavedChangesPrompt>
      )}
    </ContentLoading>
  );
}

TotalRewardPerkEdit.propTypes = {
  match: matchPropTypes.isRequired,
};
